module.exports = __webpack_public_path__ + "img/3_3_1.06dab8bc.jpg";